export default __webpack_public_path__ + "static/media/img-mobile.d59a4427.svg";